import React from 'react';
import './NotFound.scss';

const NotFound = props => (
    <div className='NotFound'>
        <h1>NotFound</h1>
        <h2>error 404</h2> 
    </div>
)

export default NotFound;